import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import { Grid, makeStyles } from "@material-ui/core";
import _ from "lodash";
import { Button, Typography, Page } from "@packages/ui";
import * as constants from "../../utils/constants";
import { useCurrentRental } from "src/hooks/rentalHooks";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
}));

const DamageDocumentation = () => {
  const classes = useStyles();
  const currentRental = useCurrentRental();
  const damagePhotos = _.get(currentRental, "damage_data.damage_photos_locations", []).filter(
    (p) => _.endsWith(p.toLowerCase(), ".jpg") || _.endsWith(p.toLowerCase(), ".png")
  );
  const damagePhotosZip = _.get(
    currentRental,
    "damage_data.damage_photos_locations",
    []
  ).filter((p) => _.endsWith(p.toLowerCase(), ".zip"));
  const damagePhotosPdf = _.get(
    currentRental,
    "damage_data.damage_photos_locations",
    []
  ).filter((p) => _.endsWith(p.toLowerCase(), ".pdf"));
  const [lightbox, setLightbox] = useState({ photoIndex: 0, isOpen: false });

  function handleOnClick(e) {
    setLightbox({ photoIndex: e.target.name, isOpen: true });
  }

  return (
    <Page className={classes.root} title="Damage Documentation - My Journey Portal">
      <Grid container direction="row">
        <Grid item xs={12}>
          <Typography variant={"h1"} style={{ marginBottom: 30 }}>
            Damage Documentation
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            The vehicle assigned to your rental{" "}
            <strong>(RA#{currentRental.rental_agreement_number})</strong> was returned in a damaged
            condition following your recent rental.
          </Typography>
        </Grid>
        <br />
        <br />
        <Grid item xs={12}>
          {currentRental?.damage_data?.damage_photos_locations.length > 0 ? (
            <Typography>
              Below are a set of photographs of this vehicle together with panel damage estimates
              and assessments (if applicable). You may view and download these documents for your
              own records.
            </Typography>
          ) : (
            <Typography>
              We have detected damage on your rental and are collating necessary documentation. This
              will be updated shortly. Please check back later to view images and repair invoices
              relating to your rental.
            </Typography>
          )}
        </Grid>
        {Object.keys(damagePhotosZip).map((key) => (
          <div key={key}>
            <a href={damagePhotosZip[key]}>
              <Button
                color="yellow"
                title={"Download All Documents"}
                style={{ marginTop: 30 }}
              ></Button>
            </a>
          </div>
        ))}
        <br />
        <Grid container spacing={2} style={{ marginTop: 30 }}>
          {damagePhotosPdf.map((value, index) => (
            <Grid
              key={index}
              item
              lg={3}
              sm={3}
              xl={1}
              xs={4}
              style={{ textAlign: "center", overflowWrap: "anywhere" }}
            >
              {/* if the last 3 letters are pdf then make the pdf image and click to download */}
              <a
                key={index}
                style={{ display: "inline", cursor: "pointer" }}
                value={value}
                href={value}
                target={"_blank"}
                rel="noreferrer"
              >
                <img src={constants.PDF_ICON} width="100%" />
                {value.substring(value.lastIndexOf("/") + 1)}
              </a>
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 30 }}>
          {Object.keys(damagePhotos).map((key, index) => (
            <Grid key={index} item lg={3} sm={6} xl={3} xs={12}>
              <a
                key={index}
                onClick={(e) => handleOnClick(e)}
                style={{ display: "inline", cursor: "pointer" }}
                value={index}
              >
                <img name={index} src={damagePhotos[key]} width="100%" />
              </a>
            </Grid>
          ))}
        </Grid>
        {lightbox.isOpen && (
          <Lightbox
            mainSrc={damagePhotos[lightbox.photoIndex]}
            nextSrc={damagePhotos[(lightbox.photoIndex + 1) % damagePhotos.length]}
            prevSrc={
              damagePhotos[(lightbox.photoIndex + damagePhotos.length - 1) % damagePhotos.length]
            }
            onCloseRequest={() => setLightbox({ photoIndex: 0, isOpen: false })}
            onMovePrevRequest={() =>
              setLightbox({
                photoIndex: (lightbox.photoIndex + damagePhotos.length - 1) % damagePhotos.length,
                isOpen: true,
              })
            }
            onMoveNextRequest={() =>
              setLightbox({
                photoIndex: (lightbox.photoIndex + 1) % damagePhotos.length,
                isOpen: true,
              })
            }
            reactModalStyle={{ zIndex: 2000 }}
          />
        )}
      </Grid>
    </Page>
  );
};

export default DamageDocumentation;
